import React from "react";
import { VariantProps } from "..";
import MapOverride from "./MapOverride";
import Registered from "../Registered";

const M = ({
  user,
  selectedProduct,
  productListingView,
  setIsQuantityDiscountPopoverOpen,
}: VariantProps) => {
  return user.registered &&
    (selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      selectedProduct.showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers) ? (
    <Registered
      {...{
        user,
        selectedProduct,
        setIsQuantityDiscountPopoverOpen,
      }}
    />
  ) : (
    <div className="map map-override mapM">
      <MapOverride
        productListingView={productListingView}
        enabled={
          selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers
        }
      />
    </div>
  );
};

export default M;
